export default __webpack_public_path__ + "img/dMgREcoh.832184ea.svg";